import api from "@/services/api";
import { FranchiseAssociateListItem } from "@/types/franchise-associate/FranchiseAssociate";

class ListFranchiseAssociates {
  execute = async () => {
    const response = await api().get("/franchise-associates");
    return response.data as FranchiseAssociateListItem[];
  };
}

export { ListFranchiseAssociates };
